/**
 * What a session's live events do to the strings they carry (`redactEventData`
 * in `types.ts`), apart from that module, which loads Node modules, so the
 * browser can tell a string an event changed from the saved transcript's whole one.
 */

/** What an event puts after a string it cut at `CODE_SESSION_EVENT_STRING_MAX_BYTES`. */
export const TRUNCATED_MARKER = '…[truncated]';

// What the redactor writes over what looks like a credential (`redactText`),
// which includes any long mixed-case run of letters and digits, such as the
// base64 of a data: URL.
const REDACTED_MARKER = '[REDACTED]';

/** Whether a live event cut `value` short or hid part of it. */
export function isAlteredEventString(value: string): boolean {
  return value.endsWith(TRUNCATED_MARKER) || value.includes(REDACTED_MARKER);
}
